import { FETCHING_TRANSACTION_SUMMARY, FETCH_TRANSACTION_SUMMARY_SUCCESS } from "./TransactionSummaryConstants";

const initialState = {
  fetchingTransactionSummary: false,
  transactions: {}
};

const TransactionSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_TRANSACTION_SUMMARY:
      return { ...state, fetchingTransactionSummary: true };
    case FETCH_TRANSACTION_SUMMARY_SUCCESS:
      return { ...state, fetchingTransactionSummary: false, transactions: action.transactions };
    default:
      return state;
  }
};

export default TransactionSummaryReducer;



// WEBPACK FOOTER //
// ./src/redux/transactionSummary/TransactionSummaryReducer.js